import { SubscriptionPlan } from '@modules-deprecated/app/organization/enums/subscriptionPlan'

import { resolveSubscriptionPlan } from './resolveSubscriptionPlan'

const trialPlans = new Set([SubscriptionPlan.PlusTrial, SubscriptionPlan.PremiumTrial])

export const getVisiblePlans = (currentPlan: SubscriptionPlan, market?: 'de' | 'fr' | 'nl'): SubscriptionPlan[] => {
  const { plan, displayAs, behavior } = resolveSubscriptionPlan(currentPlan, market)
  const effectivePlan = displayAs ?? plan
  const upgradableTo = behavior?.upgradableTo ?? []

  if (trialPlans.has(effectivePlan)) {
    return upgradableTo
  }

  return [effectivePlan, ...upgradableTo]
}
